import React from 'react';
import { ExternalOffices, SpecialistUnit } from '../../../../models/Specialist';
import { capitalize } from '../../../../utils/formatters';

import { Container, Title, Subtitle } from './styles';

type UnitAddressProps = {
  unit: SpecialistUnit | ExternalOffices;
};

export const UnitAddress: React.FC<UnitAddressProps> = ({ unit }) => {
  return (
    <Container>
      <Title>{unit.name && capitalize(unit.name)}</Title>
      <Subtitle>{unit.full_address}</Subtitle>
    </Container>
  );
};
